export const statusTexts = {
  done: 'Подтвержден',
  progress: 'Не подтвержден',
  canceled: 'Ошибка',
}
